import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import {style} from "variables/Variables.jsx";
import '../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";
import * as moment from "moment";
import {Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

var monthOptions = [];
for(var i=-2; i<=11; i++){
    let date = new Date();
    date.setMonth(date.getMonth() - i);
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear();
    let monthName = monthNames[date.getMonth()];
    monthOptions.push({
        value: year + '-' + month + '-01',
        label: monthName + ' ' + year
    });
}

class MonthlyTargetsConfig extends Component {
    constructor(props) {
        super(props);

        // Get current month option
        const currentDate = new Date();
        const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const currentYear = currentDate.getFullYear();
        const currentMonthValue = currentYear + '-' + currentMonth + '-01';
        const currentMonthLabel = monthNames[currentDate.getMonth()] + ' ' + currentYear;

        this.state = {
            targets_data: [],

            addTargetModal: false,
            action_type: '',
            loading: false,
            saving: false,

            // Form fields
            template_id: '',
            month_year: {value: currentMonthValue, label: currentMonthLabel},

            // OKR Parent Weightages - empty by default
            okr_weightage_beat_plan_gtv: '',
            okr_weightage_acquisition: '',

            // GTV Components
            okr_weightage_beat_plan_stores: '',
            okr_weightage_brand_transactions: '',
            okr_weightage_genie_cash_gtv: '',

            // Acquisition Components
            okr_weightage_genie_on_link: '',
            okr_weightage_boost: '',
            okr_weightage_genie: '',

            // Thresholds
            beat_plan_gtv_threshold: '',
            brand_transactions_threshold: '',
            genie_cash_gtv_threshold: '',

            // Acquisition Targets
            genie_on_link_acquisition_target: '',
            boost_acquisition_target: '',
            genie_acquisition_target: '',

            // Validation
            parent_total: 0,
            parent_valid: false,
            gtv_components_total: 0,
            gtv_valid: false,
            acq_components_total: 0,
            acq_valid: false,

            email: ''
        };
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        if (token) {
            try {
                const decoded = jwt_decode(token);
                if (decoded && decoded.email) {
                    this.setState({ email: decoded.email });
                }
            } catch (e) {
                console.error('Token decode error:', e);
            }
        }

        // Fetch all templates for table
        this.fetchTemplates();

        // Fetch data for current month (already selected)
        if (this.state.month_year.value) {
            this.fetchTemplateByMonth(this.state.month_year.value);
        }
    }

    fetchTemplates() {
        this.setState({ loading: true });

        axios.get(
            config.get('API_URL') + '/summaryReport/get_sales_targets_templates/',
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }
        )
        .then((response) => {
            if (response.data.status === 'success') {
                this.setState({
                    targets_data: response.data.data || [],
                    loading: false
                }, () => {
                    // Reinitialize DataTable
                    if ($.fn.DataTable.isDataTable('#TargetsTable')) {
                        $('#TargetsTable').DataTable().destroy();
                    }
                    setTimeout(() => {
                        $('#TargetsTable').DataTable();
                    }, 100);
                });
            } else {
                this.setState({ loading: false });
            }
        })
        .catch((err) => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    fetchTemplateByMonth(monthYear) {
        axios.post(
            config.get('API_URL') + '/summaryReport/get_sales_target_by_month/',
            { month_year: monthYear },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }
        )
        .then((response) => {
            if (response.data.status === 'success' && response.data.data) {
                const data = response.data.data;
                // Populate form fields with existing data
                this.setState({
                    template_id: data.template_id || '',
                    okr_weightage_beat_plan_gtv: data.okr_weightage_beat_plan_gtv?.toString() || '',
                    okr_weightage_acquisition: data.okr_weightage_acquisition?.toString() || '',
                    okr_weightage_beat_plan_stores: data.okr_weightage_beat_plan_stores?.toString() || '',
                    okr_weightage_brand_transactions: data.okr_weightage_brand_transactions?.toString() || '',
                    okr_weightage_genie_cash_gtv: data.okr_weightage_genie_cash_gtv?.toString() || '',
                    okr_weightage_genie_on_link: data.okr_weightage_genie_on_link?.toString() || '',
                    okr_weightage_boost: data.okr_weightage_boost?.toString() || '',
                    okr_weightage_genie: data.okr_weightage_genie?.toString() || '',
                    beat_plan_gtv_threshold: data.beat_plan_gtv_threshold?.toString() || '',
                    brand_transactions_threshold: data.brand_transactions_threshold?.toString() || '',
                    genie_cash_gtv_threshold: data.genie_cash_gtv_threshold?.toString() || '',
                    genie_on_link_acquisition_target: data.genie_on_link_acquisition_target?.toString() || '',
                    boost_acquisition_target: data.boost_acquisition_target?.toString() || '',
                    genie_acquisition_target: data.genie_acquisition_target?.toString() || ''
                }, () => {
                    this.validateOKR();
                });
            } else {
                // No data for this month - clear form
                this.clearFormFields();
            }
        })
        .catch((err) => {
            console.error(err);
            // Error or no data - clear form
            this.clearFormFields();
        });
    }

    clearFormFields() {
        this.setState({
            template_id: '',
            okr_weightage_beat_plan_gtv: '',
            okr_weightage_acquisition: '',
            okr_weightage_beat_plan_stores: '',
            okr_weightage_brand_transactions: '',
            okr_weightage_genie_cash_gtv: '',
            okr_weightage_genie_on_link: '',
            okr_weightage_boost: '',
            okr_weightage_genie: '',
            beat_plan_gtv_threshold: '',
            brand_transactions_threshold: '',
            genie_cash_gtv_threshold: '',
            genie_on_link_acquisition_target: '',
            boost_acquisition_target: '',
            genie_acquisition_target: '',
            parent_total: 0,
            parent_valid: false,
            gtv_components_total: 0,
            gtv_valid: false,
            acq_components_total: 0,
            acq_valid: false
        });
    }

    toggleAddTargetModal() {
        this.setState({
            addTargetModal: !this.state.addTargetModal
        });
    }

    clearForm() {
        // Get current month
        const currentDate = new Date();
        const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const currentYear = currentDate.getFullYear();
        const currentMonthValue = currentYear + '-' + currentMonth + '-01';
        const currentMonthLabel = monthNames[currentDate.getMonth()] + ' ' + currentYear;

        this.setState({
            template_id: '',
            month_year: {value: currentMonthValue, label: currentMonthLabel},
            okr_weightage_beat_plan_gtv: '',
            okr_weightage_acquisition: '',
            okr_weightage_beat_plan_stores: '',
            okr_weightage_brand_transactions: '',
            okr_weightage_genie_cash_gtv: '',
            okr_weightage_genie_on_link: '',
            okr_weightage_boost: '',
            okr_weightage_genie: '',
            beat_plan_gtv_threshold: '',
            brand_transactions_threshold: '',
            genie_cash_gtv_threshold: '',
            genie_on_link_acquisition_target: '',
            boost_acquisition_target: '',
            genie_acquisition_target: '',
            parent_total: 0,
            parent_valid: false,
            gtv_components_total: 0,
            gtv_valid: false,
            acq_components_total: 0,
            acq_valid: false
        }, () => {
            // Fetch data for current month
            this.fetchTemplateByMonth(currentMonthValue);
        });
    }

    editTarget(target) {
        const month_option = monthOptions.find(m => m.value === target.month_year);

        this.setState({
            template_id: target.template_id,
            month_year: month_option || {value: '', label: 'Select Month'},
            okr_weightage_beat_plan_gtv: target.okr_weightage_beat_plan_gtv?.toString() || '',
            okr_weightage_acquisition: target.okr_weightage_acquisition?.toString() || '',
            okr_weightage_beat_plan_stores: target.okr_weightage_beat_plan_stores?.toString() || '',
            okr_weightage_brand_transactions: target.okr_weightage_brand_transactions?.toString() || '',
            okr_weightage_genie_cash_gtv: target.okr_weightage_genie_cash_gtv?.toString() || '',
            okr_weightage_genie_on_link: target.okr_weightage_genie_on_link?.toString() || '',
            okr_weightage_boost: target.okr_weightage_boost?.toString() || '',
            okr_weightage_genie: target.okr_weightage_genie?.toString() || '',
            beat_plan_gtv_threshold: target.beat_plan_gtv_threshold?.toString() || '',
            brand_transactions_threshold: target.brand_transactions_threshold?.toString() || '',
            genie_cash_gtv_threshold: target.genie_cash_gtv_threshold?.toString() || '',
            genie_on_link_acquisition_target: target.genie_on_link_acquisition_target?.toString() || '',
            boost_acquisition_target: target.boost_acquisition_target?.toString() || '',
            genie_acquisition_target: target.genie_acquisition_target?.toString() || '',
            addTargetModal: true
        }, () => {
            this.validateOKR();
        });
    }

    changeMonth(optionSelected) {
        const monthOption = optionSelected || {value: '', label: 'Select Month'};
        this.setState({
            month_year: monthOption
        }, () => {
            // Fetch data for selected month
            if (monthOption.value) {
                this.fetchTemplateByMonth(monthOption.value);
            }
        });
    }

    onChangeInput(e) {
        const fieldName = e.target.name;
        const fieldValue = e.target.value;

        this.setState({
            [fieldName]: fieldValue
        }, () => {
            if (fieldName && fieldName.includes('okr_weightage')) {
                this.validateOKR();
            }
        });
    }

    validateOKR() {
        const parent_gtv = parseFloat(this.state.okr_weightage_beat_plan_gtv || 0);
        const parent_acq = parseFloat(this.state.okr_weightage_acquisition || 0);
        const parent_total = parent_gtv + parent_acq;

        const gtv_total =
            parseFloat(this.state.okr_weightage_beat_plan_stores || 0) +
            parseFloat(this.state.okr_weightage_brand_transactions || 0) +
            parseFloat(this.state.okr_weightage_genie_cash_gtv || 0);

        const acq_total =
            parseFloat(this.state.okr_weightage_genie_on_link || 0) +
            parseFloat(this.state.okr_weightage_boost || 0) +
            parseFloat(this.state.okr_weightage_genie || 0);

        this.setState({
            parent_total: parent_total.toFixed(2),
            parent_valid: Math.abs(parent_total - 100.00) < 0.01,
            gtv_components_total: gtv_total.toFixed(2),
            gtv_valid: Math.abs(gtv_total - parent_gtv) < 0.01,
            acq_components_total: acq_total.toFixed(2),
            acq_valid: Math.abs(acq_total - parent_acq) < 0.01
        });
    }

    isFormValid() {
        return (
            this.state.month_year.value &&
            this.state.parent_valid &&
            this.state.gtv_valid &&
            this.state.acq_valid
        );
    }

    saveTarget() {
        if (!this.state.month_year.value) {
            this.props.handleClick("tr", 3, "Please select a month");
            return;
        }
        if (!this.state.parent_valid) {
            this.props.handleClick("tr", 3, "GTV + Acquisition must equal 100%");
            return;
        }
        if (!this.state.gtv_valid) {
            this.props.handleClick("tr", 3, `GTV Components must equal ${this.state.okr_weightage_beat_plan_gtv}%`);
            return;
        }
        if (!this.state.acq_valid) {
            this.props.handleClick("tr", 3, `Acquisition Components must equal ${this.state.okr_weightage_acquisition}%`);
            return;
        }

        const data = {
            template_id: this.state.template_id,
            month_year: this.state.month_year.value,
            okr_weightage_beat_plan_gtv: parseFloat(this.state.okr_weightage_beat_plan_gtv),
            okr_weightage_acquisition: parseFloat(this.state.okr_weightage_acquisition),
            okr_weightage_beat_plan_stores: parseFloat(this.state.okr_weightage_beat_plan_stores),
            okr_weightage_brand_transactions: parseFloat(this.state.okr_weightage_brand_transactions),
            okr_weightage_genie_cash_gtv: parseFloat(this.state.okr_weightage_genie_cash_gtv),
            okr_weightage_genie_on_link: parseFloat(this.state.okr_weightage_genie_on_link),
            okr_weightage_boost: parseFloat(this.state.okr_weightage_boost),
            okr_weightage_genie: parseFloat(this.state.okr_weightage_genie),
            beat_plan_gtv_threshold: parseFloat(this.state.beat_plan_gtv_threshold),
            brand_transactions_threshold: parseFloat(this.state.brand_transactions_threshold),
            genie_cash_gtv_threshold: parseFloat(this.state.genie_cash_gtv_threshold),
            genie_on_link_acquisition_target: parseInt(this.state.genie_on_link_acquisition_target),
            boost_acquisition_target: parseInt(this.state.boost_acquisition_target),
            genie_acquisition_target: parseInt(this.state.genie_acquisition_target),
            created_by: this.state.email
        };

        this.setState({ saving: true });

        axios.post(
            config.get('API_URL') + '/summaryReport/save_sales_targets_template/',
            data,
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }
        )
        .then((response) => {
            this.setState({ saving: false });
            if (response.data.status === 'success') {
                this.setState({ addTargetModal: false });
                this.props.handleClick("tr", 1, response.data.message || "Targets saved successfully");
                // Refresh table data
                this.fetchTemplates();
            } else {
                this.props.handleClick("tr", 3, response.data.message || "Error saving targets");
            }
        })
        .catch((err) => {
            console.error(err);
            this.setState({ saving: false });
            this.props.handleClick("tr", 3, "Error: " + err.message);
        });
    }

    render() {
        const customStyles = {
            control: provided => ({ ...provided, padding: "0px", minHeight: "34px" }),
            indicatorsContainer: provided => ({ ...provided, height: "34px" }),
            valueContainer: base => ({ ...base, padding: '0px 6px' }),
            menu: styles => ({ ...styles, zIndex: 999 }),
        };

        let targetsTableData = this.state.targets_data.map((target, index) => {
            return (
                <tr key={index + 1}>
                    <td>{target.month_display}</td>
                    <td>
                        <strong>GTV ({target.okr_weightage_beat_plan_gtv}%):</strong> {target.okr_weightage_beat_plan_stores}% + {target.okr_weightage_brand_transactions}% + {target.okr_weightage_genie_cash_gtv}%<br/>
                        <strong>Acq ({target.okr_weightage_acquisition}%):</strong> {target.okr_weightage_genie_on_link}% + {target.okr_weightage_boost}% + {target.okr_weightage_genie}%
                    </td>
                    <td>
                        BP: ₹{target.beat_plan_gtv_threshold?.toLocaleString()}<br/>
                        Brand: ₹{target.brand_transactions_threshold?.toLocaleString()}<br/>
                        GC: ₹{target.genie_cash_gtv_threshold?.toLocaleString()}
                    </td>
                    <td>
                        GoL: {target.genie_on_link_acquisition_target}<br/>
                        Boost: {target.boost_acquisition_target}<br/>
                        Genie: {target.genie_acquisition_target}
                    </td>
                    <td>{moment(target.created_at).format('D MMM YYYY')}</td>
                    <td>{target.created_by}</td>
                    <td className="text-center">
                        <a href="#" className="btn btn-default actionBtn btn-edit" role="button"
                           onClick={this.editTarget.bind(this, target)}>
                            <span className="glyphicon glyphicon-edit" aria-hidden="true"></span>
                        </a>
                    </td>
                </tr>
            );
        });

        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <NotificationSystem ref="notificationSystem" style={style} />
                            <div className="card">
                                <div className="content table-full-width table-responsive nomargin">
                                    <div className="col-md-8">
                                        <h4 className="title">Monthly Sales Targets Configuration</h4>
                                        <p className="category">Master template - applies to all ICs and Managers</p>
                                    </div>
                                    <div className="col-md-4 pull-right" style={{textAlign:'right'}}>
                                        <a href="#" className="addButton" role="button"
                                           onClick={this.toggleAddTargetModal.bind(this)}>
                                            <span className="glyphicon glyphicon-cog" aria-hidden="true"></span>
                                            Configure Targets
                                        </a>
                                    </div>

                                    <table id="TargetsTable" className="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Month</th>
                                                <th>OKR Weightages</th>
                                                <th>Thresholds</th>
                                                <th>Acquisition Targets<br/><small>(per IC)</small></th>
                                                <th>Created</th>
                                                <th>By</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>{targetsTableData}</tbody>
                                    </table>

                                    <BeatLoader css={override} sizeUnit={"px"} size={20} color={'#123abc'} loading={this.state.loading} />

                                    {/* ═══════════════════════════════════════════════════════════════ */}
                                    {/* MODAL */}
                                    {/* ═══════════════════════════════════════════════════════════════ */}
                                    <Modal isOpen={this.state.addTargetModal} toggle={this.toggleAddTargetModal.bind(this)} size="lg">
                                        <ModalHeader toggle={this.toggleAddTargetModal.bind(this)}>
                                            {this.state.template_id ? 'Edit' : 'Add'} Targets - {this.state.month_year.label}
                                        </ModalHeader>
                                        <ModalBody className="user_form_fields">

                                            {/* Month Selection */}
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <FormGroup>
                                                        <Label>Select Month <span style={{color: 'red'}}>*</span></Label>
                                                        <Select
                                                            name="month_year"
                                                            value={this.state.month_year}
                                                            styles={customStyles}
                                                            isClearable={false}
                                                            onChange={this.changeMonth.bind(this)}
                                                            options={monthOptions}
                                                            placeholder="Select Month"
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>

                                            <hr/>

                                            {/* ═══════════════════════════════════════════════════════════════ */}
                                            {/* OKR Weightages - Single Section */}
                                            {/* ═══════════════════════════════════════════════════════════════ */}
                                            <h5><strong>OKR Weightages</strong></h5>

                                            {/* Parent: GTV + Acquisition = 100% */}
                                            <div className="row" style={{backgroundColor: '#e3f2fd', padding: '15px', marginBottom: '15px', borderRadius: '5px'}}>
                                                <div className="col-md-5">
                                                    <FormGroup style={{marginBottom: 0}}>
                                                        <Label><strong>GTV Weightage (%)</strong></Label>
                                                        <Input
                                                            type="number"
                                                            step="0.01"
                                                            name="okr_weightage_beat_plan_gtv"
                                                            value={this.state.okr_weightage_beat_plan_gtv}
                                                            onChange={this.onChangeInput.bind(this)}
                                                            style={{fontWeight: 'bold', fontSize: '18px', textAlign: 'center'}}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-2" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '30px'}}>
                                                    <strong style={{fontSize: '24px'}}>+</strong>
                                                </div>
                                                <div className="col-md-5">
                                                    <FormGroup style={{marginBottom: 0}}>
                                                        <Label><strong>Acquisition Weightage (%)</strong></Label>
                                                        <Input
                                                            type="number"
                                                            step="0.01"
                                                            name="okr_weightage_acquisition"
                                                            value={this.state.okr_weightage_acquisition}
                                                            onChange={this.onChangeInput.bind(this)}
                                                            style={{fontWeight: 'bold', fontSize: '18px', textAlign: 'center'}}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>

                                            <div className={`alert ${this.state.parent_valid ? 'alert-success' : 'alert-danger'}`} style={{padding: '10px 15px', textAlign: 'center'}}>
                                                <strong style={{fontSize: '16px'}}>
                                                    Total: {this.state.parent_total}%
                                                    {this.state.parent_valid ? ' ✓' : ' ✗ Must equal 100%'}
                                                </strong>
                                            </div>

                                            {/* GTV Components */}
                                            <div style={{backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '5px', marginBottom: '15px'}}>
                                                <h6>
                                                    <strong style={{color: '#1976d2'}}>GTV Components</strong>
                                                    <span className={`badge ${this.state.gtv_valid ? 'badge-success' : 'badge-danger'}`} style={{marginLeft: '10px', fontSize: '12px'}}>
                                                        Must = {this.state.okr_weightage_beat_plan_gtv}%
                                                    </span>
                                                </h6>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <FormGroup>
                                                            <Label>Beat Plan Stores (%)</Label>
                                                            <Input
                                                                type="number"
                                                                step="0.01"
                                                                name="okr_weightage_beat_plan_stores"
                                                                value={this.state.okr_weightage_beat_plan_stores}
                                                                onChange={this.onChangeInput.bind(this)}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <FormGroup>
                                                            <Label>Brand Transactions (%)</Label>
                                                            <Input
                                                                type="number"
                                                                step="0.01"
                                                                name="okr_weightage_brand_transactions"
                                                                value={this.state.okr_weightage_brand_transactions}
                                                                onChange={this.onChangeInput.bind(this)}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <FormGroup>
                                                            <Label>Genie Cash GTV (%)</Label>
                                                            <Input
                                                                type="number"
                                                                step="0.01"
                                                                name="okr_weightage_genie_cash_gtv"
                                                                value={this.state.okr_weightage_genie_cash_gtv}
                                                                onChange={this.onChangeInput.bind(this)}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                                <div className={`alert ${this.state.gtv_valid ? 'alert-success' : 'alert-danger'}`} style={{padding: '5px 10px', marginBottom: 0}}>
                                                    <small><strong>Total: {this.state.gtv_components_total}%</strong>
                                                    {this.state.gtv_valid ? ' ✓' : ` ✗ Must = ${this.state.okr_weightage_beat_plan_gtv}%`}</small>
                                                </div>
                                            </div>

                                            {/* Acquisition Components */}
                                            <div style={{backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '5px', marginBottom: '15px'}}>
                                                <h6>
                                                    <strong style={{color: '#388e3c'}}>Acquisition Components</strong>
                                                    <span className={`badge ${this.state.acq_valid ? 'badge-success' : 'badge-danger'}`} style={{marginLeft: '10px', fontSize: '12px'}}>
                                                        Must = {this.state.okr_weightage_acquisition}%
                                                    </span>
                                                </h6>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <FormGroup>
                                                            <Label>Genie on Link (%)</Label>
                                                            <Input
                                                                type="number"
                                                                step="0.01"
                                                                name="okr_weightage_genie_on_link"
                                                                value={this.state.okr_weightage_genie_on_link}
                                                                onChange={this.onChangeInput.bind(this)}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <FormGroup>
                                                            <Label>Boost (%)</Label>
                                                            <Input
                                                                type="number"
                                                                step="0.01"
                                                                name="okr_weightage_boost"
                                                                value={this.state.okr_weightage_boost}
                                                                onChange={this.onChangeInput.bind(this)}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <FormGroup>
                                                            <Label>Genie (%)</Label>
                                                            <Input
                                                                type="number"
                                                                step="0.01"
                                                                name="okr_weightage_genie"
                                                                value={this.state.okr_weightage_genie}
                                                                onChange={this.onChangeInput.bind(this)}
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                                <div className={`alert ${this.state.acq_valid ? 'alert-success' : 'alert-danger'}`} style={{padding: '5px 10px', marginBottom: 0}}>
                                                    <small><strong>Total: {this.state.acq_components_total}%</strong>
                                                    {this.state.acq_valid ? ' ✓' : ` ✗ Must = ${this.state.okr_weightage_acquisition}%`}</small>
                                                </div>
                                            </div>

                                            <hr/>

                                            {/* ═══════════════════════════════════════════════════════════════ */}
                                            {/* Thresholds */}
                                            {/* ═══════════════════════════════════════════════════════════════ */}
                                            <h5><strong>Thresholds</strong></h5>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Beat Plan GTV (₹)</Label>
                                                        <Input
                                                            type="number"
                                                            name="beat_plan_gtv_threshold"
                                                            value={this.state.beat_plan_gtv_threshold}
                                                            onChange={this.onChangeInput.bind(this)}
                                                        />
                                                        <small className="text-muted">Min GTV per store</small>
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Brand Transactions (₹)</Label>
                                                        <Input
                                                            type="number"
                                                            name="brand_transactions_threshold"
                                                            value={this.state.brand_transactions_threshold}
                                                            onChange={this.onChangeInput.bind(this)}
                                                        />
                                                        <small className="text-muted">Min brand txn per store</small>
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Genie Cash GTV (₹)</Label>
                                                        <Input
                                                            type="number"
                                                            name="genie_cash_gtv_threshold"
                                                            value={this.state.genie_cash_gtv_threshold}
                                                            onChange={this.onChangeInput.bind(this)}
                                                        />
                                                        <small className="text-muted">Min Genie Cash per store</small>
                                                    </FormGroup>
                                                </div>
                                            </div>

                                            <hr/>

                                            {/* ═══════════════════════════════════════════════════════════════ */}
                                            {/* Acquisition Targets */}
                                            {/* ═══════════════════════════════════════════════════════════════ */}
                                            <h5><strong>Acquisition Targets</strong> <small className="text-muted">(per IC per month)</small></h5>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Genie on Link</Label>
                                                        <Input
                                                            type="number"
                                                            name="genie_on_link_acquisition_target"
                                                            value={this.state.genie_on_link_acquisition_target}
                                                            onChange={this.onChangeInput.bind(this)}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Boost</Label>
                                                        <Input
                                                            type="number"
                                                            name="boost_acquisition_target"
                                                            value={this.state.boost_acquisition_target}
                                                            onChange={this.onChangeInput.bind(this)}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-4">
                                                    <FormGroup>
                                                        <Label>Genie</Label>
                                                        <Input
                                                            type="number"
                                                            name="genie_acquisition_target"
                                                            value={this.state.genie_acquisition_target}
                                                            onChange={this.onChangeInput.bind(this)}
                                                        />
                                                    </FormGroup>
                                                </div>
                                            </div>

                                            <div className="alert alert-info" style={{padding: '10px 15px'}}>
                                                <strong>Total per IC: {
                                                    parseInt(this.state.genie_on_link_acquisition_target || 0) +
                                                    parseInt(this.state.boost_acquisition_target || 0) +
                                                    parseInt(this.state.genie_acquisition_target || 0)
                                                } acquisitions/month</strong>
                                                <br/>
                                                <small>Manager targets = IC target × team size (calculated automatically)</small>
                                            </div>

                                        </ModalBody>
                                        <ModalFooter>
                                            <Button
                                                color="primary"
                                                onClick={this.saveTarget.bind(this)}
                                                disabled={!this.isFormValid() || this.state.saving}
                                            >
                                                {this.state.saving ? 'Saving...' : (this.state.template_id ? 'Update' : 'Save')}
                                            </Button>
                                            <Button color="secondary" onClick={this.toggleAddTargetModal.bind(this)}>
                                                Cancel
                                            </Button>
                                        </ModalFooter>
                                    </Modal>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MonthlyTargetsConfig;